import immer from 'immer';
import moment from 'moment';
import deepEqual from './deepEqual';
import deepMerge from './deepMerge';
import getDotProp from './getDotProp';
import path from './pathUtil';
import makeCancelable from './makeCancelable';
import request from './request';
import useRequest from './request/useRequest';
import sendFeedbackEmail from './sendFeedbackEmail';
import string2xml from './string2xml';
import xml2json from './xml2json';
import json2xml from './json2xml';
import getHost from './host';
import formatting from './formatting';
import auth from './auth';
import url from './url';
import history from './history';
import getPrettyError from './getPrettyError';
import copyToClipboard from './copyToClipboard';
import hooks from './hooks';
import saveFile from './saveFile';
import apiClients from './apiClients';
import contact from './contact';
import cx from './cx';
import generateGuid from './generateGuid';
import './polyfill';
export default {
  cx: cx,
  immer: immer,
  moment: moment,
  generateGuid: generateGuid,
  deepEqual: deepEqual,
  deepMerge: deepMerge,
  getDotProp: getDotProp,
  path: path,
  makeCancelable: makeCancelable,
  request: request,
  useRequest: useRequest,
  sendFeedbackEmail: sendFeedbackEmail,
  string2xml: string2xml,
  xml2json: xml2json,
  json2xml: json2xml,
  getHost: getHost,
  auth: auth,
  url: url,
  history: history,
  formatting: formatting,
  getPrettyError: getPrettyError,
  copyToClipboard: copyToClipboard,
  hooks: hooks,
  apiClients: apiClients,
  saveFile: saveFile,
  contact: contact
};